var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.77,
    height: 17.744,
    viewBox: "0 0 36.77 17.744",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_855",
    "data-name": "Groupe 855",
    transform: "translate(2787 10857)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo_White_Sisley_Paris",
    "data-name": "Logo White Sisley Paris",
    transform: "translate(-2787 -10857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M8.987,24.911a23.53,23.53,0,0,1-5.924-.836,4.114,4.114,0,0,1-3.03-3.758,5.076,5.076,0,0,1-.023-.869l.037-.278H3.284c1.78,0,3.236.006,3.236.014s-.037.151-.083.319A1.476,1.476,0,0,0,6.7,20.976c.668.761,2.3,1.138,4.929,1.138,2.677,0,4.467-.367,5.31-1.09a1.677,1.677,0,0,0,.365-1.962,2.237,2.237,0,0,0-1.661-1.175,9.994,9.994,0,0,0-2.273-.166C8,17.578,6.275,17.455,4.426,17.08a5.172,5.172,0,0,1-2.952-1.355,3.067,3.067,0,0,1-.709-.945,4.421,4.421,0,0,1-.479-2.473A4.527,4.527,0,0,1,.41,10.754a5.54,5.54,0,0,1,.33-.833A4.449,4.449,0,0,1,2.2,8.425,13.433,13.433,0,0,1,7.358,7.3c1.377-.122,7.236-.143,8.56-.03A13.733,13.733,0,0,1,20.853,8.3a3.746,3.746,0,0,1,1.829,2.341,8.343,8.343,0,0,1,.2,1.406v.182H16.741l-.1-.457c-.187-.871-.517-1.3-1.137-1.488a11.378,11.378,0,0,0-3.109-.26,14.993,14.993,0,0,0-3.668.2A3.248,3.248,0,0,0,7.073,11a1.34,1.34,0,0,0-.458,1.206c.012.863.31,1.369.906,1.541a38.241,38.241,0,0,0,5.653.423c4.937.182,7.68.591,8.932,1.333a3.413,3.413,0,0,1,1.264,1.4,4.275,4.275,0,0,1,.422,2.375,4.278,4.278,0,0,1-.446,2.407c-1.048,2.079-3.392,2.924-8.9,3.2C13.493,24.941,10.039,24.953,8.987,24.911Z",
    transform: "translate(0 -7.192)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_",
    "data-name": "+",
    d: "M8.534,8.328V5.94H7.25V8.328H4.862V9.612H7.25V12H8.534V9.612h2.388V8.328Z",
    transform: "translate(-2761.153 -10856.628)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSPlus);
export default __webpack_public_path__ + "static/media/SPlus.9e42956338508c8bac3c2037633f1294.svg";
export { ForwardRef as ReactComponent };